import { Venda } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<Venda>('vendas');
